import React from "react";
import styles from "./StepsComponent.module.css";
import { ReactComponent as BackIcon } from "../../assets/images/textBackIcon.svg";
import { useNavigate } from "react-router-dom";

const StepsComponent = ({
  backIcon,
  steps,
  currentStepIndex,
  onPrev,
  onNext,
}) => {
    const navigate = useNavigate();

  return (
    <div className={styles.navContainer}>
      {backIcon && (
        <div onClick={() => navigate(-1)} className={styles.backIconDiv}>
          <BackIcon width={25} height={25} />
        </div>
      )}
      <div className={styles.breadcrumb}>
        {steps.map((step, index) => (
          <span
            key={index}
            className={
              index === currentStepIndex ? styles.activeStep : styles.step
            }
          >
            {step}
            {index < steps.length - 1 && (
              <span className={styles.separator}>›</span>
            )}
          </span>
        ))}
      </div>

      <div className={styles.buttons}>
        <button
          className={styles.navButton}
          onClick={onPrev}
          disabled={currentStepIndex === 0}
        >
          Previous
        </button>
        <button
          className={styles.navButton}
          onClick={onNext}
          disabled={currentStepIndex === steps.length - 1}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default StepsComponent;
